import { defineComponent as A, openBlock as o, createElementBlock as e, mergeProps as i, unref as l, renderSlot as p, createElementVNode as n, createCommentVNode as Z } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, f = { key: 1 }, h = { key: 2 }, M = { key: 3 }, k = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconDotsThreeVertical"
}, b = /* @__PURE__ */ A({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = u(s);
    return (m, t) => (o(), e("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      p(m.$slots, "default"),
      l(a) === "bold" ? (o(), e("g", g, t[0] || (t[0] = [
        n("path", { d: "M112,60a16,16,0,1,1,16,16A16,16,0,0,1,112,60Zm16,52a16,16,0,1,0,16,16A16,16,0,0,0,128,112Zm0,68a16,16,0,1,0,16,16A16,16,0,0,0,128,180Z" }, null, -1)
      ]))) : l(a) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M176,32V224a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16V32A16,16,0,0,1,96,16h64A16,16,0,0,1,176,32Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,72a12,12,0,1,0-12-12A12,12,0,0,0,128,72Zm0,112a12,12,0,1,0,12,12A12,12,0,0,0,128,184Z" }, null, -1)
      ]))) : l(a) === "fill" ? (o(), e("g", h, t[2] || (t[2] = [
        n("path", { d: "M160,16H96A16,16,0,0,0,80,32V224a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V32A16,16,0,0,0,160,16ZM128,208a12,12,0,1,1,12-12A12,12,0,0,1,128,208Zm0-68a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm0-68a12,12,0,1,1,12-12A12,12,0,0,1,128,72Z" }, null, -1)
      ]))) : l(a) === "light" ? (o(), e("g", M, t[3] || (t[3] = [
        n("path", { d: "M118,60a10,10,0,1,1,10,10A10,10,0,0,1,118,60Zm10,58a10,10,0,1,0,10,10A10,10,0,0,0,128,118Zm0,68a10,10,0,1,0,10,10A10,10,0,0,0,128,186Z" }, null, -1)
      ]))) : l(a) === "regular" ? (o(), e("g", k, t[4] || (t[4] = [
        n("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,72a12,12,0,1,0-12-12A12,12,0,0,0,128,72Zm0,112a12,12,0,1,0,12,12A12,12,0,0,0,128,184Z" }, null, -1)
      ]))) : l(a) === "thin" ? (o(), e("g", w, t[5] || (t[5] = [
        n("path", { d: "M120,60a8,8,0,1,1,8,8A8,8,0,0,1,120,60Zm8,60a8,8,0,1,0,8,8A8,8,0,0,0,128,120Zm0,68a8,8,0,1,0,8,8A8,8,0,0,0,128,188Z" }, null, -1)
      ]))) : Z("", !0)
    ], 16));
  }
});
export {
  b as default
};
